import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentFormCredits from "./PaymentForm";

const stripePromise = loadStripe(
  "pk_live_51LH80DA4sZHccDHEMdP9c5XwpX8jVMQbwPLNSpsKCQgx6vb3t9f7q6Kbo7DuBGWySpNsP30eYQEDvpElhqo9Savr008QAkWAmY"
);

const PaymentSubscriptionCredits = (data) => {
  const { credits, amount } = data;
  console.log({credits, amount});
  
  return (
    <Elements stripe={stripePromise}>
      <PaymentFormCredits credits={credits} amount={amount} />
    </Elements>
  );
};

export default PaymentSubscriptionCredits;
